import { createAction, props } from '@ngrx/store';
import { MedicalOfficesResultsWithError } from '../../../pages/basic-insurance/basic-insurance-selection-page/medic-selection-overlay/medic-search/medic-search.component';
import { FlyoutOption } from 'visana-ui-library';
import { Address } from '../../../pages/key-data/key-data.types';

export const setMedicSearchState = createAction(
  '[MedicSearch] Set search state',
  props<{
    nameFieldContent: string;
    saleOfferBegin: string;
    searchResults: MedicalOfficesResultsWithError | null;
    zipCodeFieldContent: FlyoutOption<Address> | null;
  }>(),
);
